<template>
  <mdb-modal :show="show" @close="show = false" info>
    <mdb-modal-header>
      <mdb-modal-title>Demandes de contacts</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body>
        <ListUsers
        id="acceptRequestListUsers"
        :users="getRequests"
        removable="true"
        @remove-user="removeContact"
        acceptable="true"
        @accept-user="addContact"
      ></ListUsers>
    </mdb-modal-body>
    <mdb-modal-footer center>
      <mdb-btn outline="orange darken-1" rounded @click="show = false">Plus tard</mdb-btn>
      <mdb-btn id="acceptAll" class="orange darken-1" rounded @click="acceptAll">Tout accepter</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>
<script>
import {
  mdbRow,
  mdbIcon,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter
} from "mdbvue";
import ListUsers from "@/components/ListUsers";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ModalEventsPage",
  components: {
    mdbIcon,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    ListUsers
  },
  computed: mapGetters("social", ["getRequests"]),
  data() {
    return {
      show: false
    };
  },
  watch: {
    getRequests: {
      immediate: true,
      handler: function(val) {
          this.show = val && val.length > 0;
          if(this.show) {
            this.$store.dispatch("social/refreshUsersRef");
          }
      }
    }
  },
  methods: {
    ...mapActions("social", ["addContact", "removeContact"]),
    acceptAll: function(){
        this.getRequests.map(uid => this.addContact(uid));
        this.show = false;
    }
  }
};
</script>